import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/key-transfers`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getTransfers({commit}, payload: { query: object }) {
    return axiosInstance.get(`${baseUrl}/`, {params: payload ? payload.query : {}}).
    then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
